import { useAppSelector } from "utils/redux/hooks";
import {
  selectAllCompanyUsersById,
  selectSampleUsersInfoById,
} from "../Global/slice";
import { CelebrateOrSupportType } from "./types";
import { Card } from "react-bootstrap";
import { getUserInfo } from "./helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPartyHorn } from "@fortawesome/pro-solid-svg-icons";
import { faHandshakeAngle } from "@fortawesome/pro-regular-svg-icons";

interface Props {
  info: CelebrateOrSupportType;
  onShowFollowUpModal: () => void;
  isSupportCard: boolean;
  isSampleCard?: boolean;
  hideScore?: boolean;
}

const CelebrateOrSupportCard = ({
  info,
  onShowFollowUpModal,
  isSupportCard,
  isSampleCard,
  hideScore,
}: Readonly<Props>) => {
  const usersById = useAppSelector(selectAllCompanyUsersById);
  const sampleUsers = useAppSelector(selectSampleUsersInfoById);
  const users = isSampleCard ? sampleUsers : usersById;
  const userInfo = users[info.userAccountId];

  const getCTASentence = () => {
    const usersName = userInfo?.firstName ?? "User";
    if (isSupportCard) {
      return (
        <p>
          Follow up with {usersName} for more context.{" "}
          <u>Here's how you can support</u>
        </p>
      );
    }

    return (
      <p>
        Celebrate {usersName} on this big win.{" "}
        <u>Here's how you can send recognition</u>
      </p>
    );
  };

  const getScoreSpan = () => {
    if (hideScore) return null;
    if (isSupportCard) {
      return (
        <span className="list-span support">
          Severity: {info.issueSpotlight?.severity} out of 10
        </span>
      );
    }
    return (
      <span className="list-span celebrate">
        Magnitude: {info.winSpotlight?.magnitude} out of 10
      </span>
    );
  };

  const getDescription = () => {
    if (isSupportCard) {
      return info.issueSpotlight?.issue;
    }
    return info.winSpotlight?.achievement;
  };

  const getTags = () => {
    const tags: string[] = [];
    if (info.isBurnoutRisk) {
      tags.push("Burnout Risk");
    }
    if (info.isTurnoverRisk) {
      tags.push("Turnover Risk");
    }
    if (!tags.length) return null;
    return (
      <div>
        {tags.map((tag) => (
          <span key={tag} className="label-tag red m-0">
            {tag}
          </span>
        ))}
      </div>
    );
  };

  return (
    <button className="no-style-button" onClick={onShowFollowUpModal}>
      <Card
        className={`celebrate-or-support-card ${
          isSupportCard ? "support" : "celebrate"
        }`}
      >
        <div className="d-flex justify-content-between">
          {getUserInfo(users, info.userAccountId, "align-items-center")}
          {getScoreSpan()}
        </div>
        <hr className="m-0" />
        <div className="row-gap-12px align-items-center">
          <div className="small-square-icon">
            <FontAwesomeIcon
              icon={isSupportCard ? faHandshakeAngle : faPartyHorn}
              className="icon"
            />
          </div>
          <p className="celebrate-or-support-card__description">
            {getDescription()}
          </p>
        </div>
        {getCTASentence()}
        <hr />
        <div className="row-gap-12px justify-content-between">
          <p className="grey-text">
            Check-in completed on{" "}
            {!!info.updated_at &&
              new Date(info.updated_at).toLocaleString("default", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
          </p>
          {getTags()}
        </div>
      </Card>
    </button>
  );
};

export default CelebrateOrSupportCard;
